import { createFileRoute } from "@tanstack/react-router";
import { Flex } from "@radix-ui/themes";

import LeftNav from "@/components/nav/LeftNav";
import ContainerWrapper from "@/components/ui/ContainerWrapper";
import OnboardingContent from "@/components/audiolab/OnboardingContent";

export const Route = createFileRoute("/audiolab/help")({
  component: RouteComponent,
  head: () => ({ meta: [{ title: "Help | Audiolab | Lutely" }] }),
});

function RouteComponent() {
  return (
    <ContainerWrapper>
      <Flex className="pt-[25px] pb-6 items-start">
        <LeftNav type="account" />
        <Flex className="flex-1 justify-center pl-0 items-start">
          <OnboardingContent showHeader={false} />
        </Flex>
      </Flex>
    </ContainerWrapper>
  );
}
